export default "__VITE_ASSET__ca292cc5__"